export enum SiteContexts {
    MARKING = 'MARKING'
}